import { render } from "./Country.vue?vue&type=template&id=19913ee4&scoped=true"
import script from "./Country.vue?vue&type=script&lang=js"
export * from "./Country.vue?vue&type=script&lang=js"

import "./Country.vue?vue&type=style&index=0&id=19913ee4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19913ee4"]])

export default __exports__